<template>
  <div>
    <search-nav @handleSearch="handleClickSearch">
      <search-nav-item-select name="year" label="연도" v-model="nav.searchYear" :list="selectYearOptions" />
      <!-- <search-nav-item-select name="type" label="구분" v-model="nav.searchType" :list="searchTypes" />
      <search-nav-item-select name="typefilter" label="" v-model="nav.searchTypeFilter" :list="searchTypeFilters" style="width: 300px !important" /> -->
    </search-nav>
    <vx-card>
      <h5 class="mb-4"><i class="dot"></i> 위험성평가 위험도 세부 현황</h5>
      <!-- CONTENT -->
      <div class="content-container">
        <!-- HEAD -->
        <div class="flex items-center justify-start gap-2 mb-3">
          <vs-select autocomplete v-model="nav.perPage" style="width: 140px">
            <vs-select-item v-for="_perPage in perPageOption" :key="`perpage_${_perPage}`" :text="`${_perPage}개씩 보기`" :value="_perPage" />
          </vs-select>
          <FilterButton
            :typeOptions="['기계공학과', '토목공학과', '건축공학과', '법학과', '기타']"
            add-filter-type="logical"
            :addOptions="[
              { label: '작업내용', type: 'input'},
              { label: '위험도', type: 'selector',
                  sub: [{label: '매우높음', value: '16~20'},
                        {label: '높음', value: '15~15'},
                        {label: '약간높음', value: '9~12'},
                        {label: '보통', value: '8~8'},
                        {label: '낮음', value: '4~6'},
                        {label: '매우낮음', value: '1~3'},] },
              { label: '평가일', type: 'dateRang'},
              ]"
            :enabled-add-option="true"
            :value="nav.filter"
            @input="filterButtonInput"
          />

          <SearchNavItemKeyword :viewLabel="true" label="학교(기관)명" v-model="nav.searchKeyword" class="ml-auto" />
        </div>
      </div>

      <!-- TABLE -->
      <table-list-page
        bodyStyle="none"
        :base-column="false"
        :download="false"
        :create="false"
        :approval="true"
        :move-project="false"
        :move-detail="false"
        :showNav="false"
        :per-page="nav.perPage"
        :list="renderTableDataList"
        :heads="[{ name: '구분' }, { name: '학교명' }, { name: '작업내용' }, { name: '위험도' }, { name: '평가일' }, { name: '부서명' }, { name: '작성자' }, { name: '문서상태' }]"
        :getCol="getCol"
        :query-search-mode="false"
        @detail="onClickDetail"
      />
    </vx-card>
  </div>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav.vue";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import FilterButton from "./components/FilterButton/FilterButton.vue";
import ColorCircleData from "./components/ColorCircleData.vue";
import KPagination from "@/components/kPagination/kPagination";
import moment from "moment";
import TableListPage from "@/views/list/TableListPage.vue";

export default {
  name: "GraphDetailHSImplementationStatus",
  components: {
    TableListPage,
    SearchNav,
    SearchNavItemSelect,
    SearchNavItemKeyword,
    FilterButton,
    ColorCircleData,
    KPagination,
  },
  data() {
    return {
      nav: {
        currentTab: "all",

        created_at: "",
        searchYear: moment().format("YYYY"),
        searchType: "",
        searchTypeFilter: "",
        searchKeyword: "",

        filter: [{ type: "type", value: ["기계공학과", "토목공학과", "건축공학과", "법학과", "기타"] }],

        perPage: 50,
        currentPage: 1,
        total: 0,
      },
      searchTypes: [{ value: "전체" }, { value: "반기" }, { value: "분기" }, { value: "월" }, { value: "일" }],
      tabIndex: 0,
      apiData: [],
      tableDataList: [],
      renderTableDataList: [],
    };
  },
  computed: {
    // 선택 가능한 연도 값은 2020년부터 내년까지
    selectYearOptions() {
      const years = [];
      const startYear = 2020;
      const endYear = new Date().getFullYear() + 1;
      for (let i = startYear; i <= endYear; i++) {
        years.push(i);
      }
      return years.reverse().map((year) => ({ value: year }));
    },
    searchTypeFilters() {
      let returnData = [{ value: "전체" }];

      if (this.nav.searchType === "반기") returnData = [{ value: "상반기" }, { value: "하반기" }];
      else if (this.nav.searchType === "분기") returnData = [{ value: "1분기" }, { value: "2분기" }, { value: "3분기" }, { value: "4분기" }];
      else if (this.nav.searchType === "월") {
        // 1~12월
        const months = [];
        for (let i = 1; i <= 12; i++) {
          months.push(i);
        }
        returnData = months.map((month) => ({ value: `${month}월` }));
      } else if (this.nav.searchType === "일") {
        // 1~31일
        const days = [];
        for (let i = 1; i <= 31; i++) {
          days.push(i);
        }
        returnData = days.map((day) => ({ value: `${day}일` }));
      }

      if (returnData.length > 0) this.nav.searchTypeFilter = returnData[0].value;
      return returnData;
    },
    perPageOption() {
      return [50, 75, 100, 125, 150];
    },
  },
  watch: {
    "nav.searchKeyword"(/*value*/) {
      if (this.nav.currentPage !== 1) this.$set(this.nav, "currentPage", 1);
      else this.setRenderTableData();
    },
    "nav.perPage"(/*value*/) {
      if (this.nav.currentPage !== 1) this.$set(this.nav, "currentPage", 1);
      else this.setRenderTableData();
    },
    "nav.currentPage"(/*value*/) {
      this.setRenderTableData();
    },
    "nav.searchYear"(/*value*/) {
      this.$set(this.nav, "currentPage", 1);
      this.loadAPI();
    },
  },
  created() {
    this.loadAPI();
  },
  methods: {
    getCol: (index, value, func) => {
      try {
        switch (index) {
        case 0: { return value.category }
        case 1: { return value.field_name }
        case 2: { return value.task }
        case 3: {
          if (16 <= value.risk && value.risk <= 20) {
            return '매우높음'
          } else if (15 === value.risk) {
            return '높음'
          } else if (9 <= value.risk && value.risk <= 12) {
            return '약간높음'
          } else if (8 === value.risk) {
            return '보통'
          } else if (4 <= value.risk && value.risk <= 6) {
            return '낮음'
          } else if (1 <= value.risk && value.risk <= 3) {
            return '매우낮음'
          }
          return value.risk
        }
        case 4: { return value.date }
        case 5: { return value.company }
        case 6: { return value.author }
        case 7: { return value.isFinishLater ? '추후보완' : '완료' }
        }
      } catch (e) { /*ignore*/ }
      return ''
    },
    checkColor (value) {
      if (value >= 1 && value <= 3) {
        return '#28C76F'
      } else if (value >= 4 && value <= 6) {
        return '#FF8510'
      } else {
        return '#E42728'
      }
    },

    // 검색 버튼 클릭
    handleClickSearch() {
      this.setTableData();
    },
    filterButtonInput(data) {
      this.nav.filter = data;
      if (this.nav.currentPage !== 1) this.$set(this.nav, "currentPage", 1);
      else this.setRenderTableData();
    },
    // 탭 이동
    moveTab(data) {
      this.nav.currentTab = data;
    },
    async loadAPI() {
      this.apiData = await this.$store.dispatch("summary/LOAD_FIELD_LIST_BY_POST_VALUE", {
        projectIds: [6],
        boardIds: [450],
        dateTarget: "content$body.inputB_4",
        dateBegin: `${this.nav.searchYear}-01-01 00:00:00`,
        dateEnd: `${this.nav.searchYear}-12-31 23:59:59`,
        valueTargets: ["body.riskAppraisalList[*].input_13_value"],
        valueOps: [">="],
        values: [9],
      });

      this.setTableData();
    },
    setTableData() {
      this.tableDataList = [];

      const checkedPostData = this.apiData.posts;
      if (checkedPostData && checkedPostData[this.nav.searchYear] && checkedPostData[this.nav.searchYear].length > 0) {
        this.tableDataList = checkedPostData[this.nav.searchYear][0];
        this.setRenderTableData();
      }
    },
    setRenderTableData() {
      let dataList = JSON.parse(JSON.stringify(this.tableDataList));

      // TODO : 검색 필터 적용
      for (const fd of this.nav.filter) {
        // 필터 구분 (기계공학과, 토목공학과, 건축공학과, 법학과, 특수학교, 기타)
        if (fd.type === "type") dataList = dataList.filter((data) => fd.value.includes(data.category));

        // 커스텀
        else if (fd.type === "buttons") {
          dataList = dataList.filter((data) => {
            if (fd.value.selectType === "전체") {
              if (fd.value.buttonInput === "미이행") return data["정기안전교육"] < 4 && data["채용시 안전교육"] < 4;
              else if (fd.value.buttonInput === "이행") return 3 < data["정기안전교육"] && 3 < data["채용시 안전교육"];
            } else {
              let key = fd.value.selectType;
              if (key === "정기안전교육") key = '정기안전교육';
              else if (key === "채용시 안전교육") key = "채용시 안전교육";

              if (fd.value.buttonInput === "미이행") return data[key] < 4;
              else if (fd.value.buttonInput === "이행") return 3 < data[key];
            }
          });
        }

        // logical
        else if (fd.type === "logical") {
          dataList = dataList.filter((data) => {
            if (fd.value.selectType === "작업내용") {
              if (fd.value.selectLogical === "포함") {
                return data.task.includes(fd.value.customInput);
              } else if (fd.value.selectLogical === "제외") {
                return !data.task.includes(fd.value.customInput);
              }
            }
            if (fd.value.selectType === "위험도") {
              const range = fd.value.customInput ? fd.value.customInput.split("~") : [0, 0];
              if (fd.value.selectLogical === "포함") {
                return (range[0] <= data.risk && data.risk <= range[1])
              } else if (fd.value.selectLogical === "제외") {
                return !(range[0] <= data.risk && data.risk <= range[1])
              }
            }
            if (fd.value.selectType === "평가일") {
              const sDate = fd.value.customInput.sDate || "1900-01-01";
              const eDate = fd.value.customInput.eDate;
              if (fd.value.selectLogical === "포함") {
                if (eDate) {
                  return new Date(sDate) <= new Date(data.date) && new Date(data.date) <= new Date(eDate);
                } else {
                  return new Date(sDate) <= new Date(data.date);
                }
              } else if (fd.value.selectLogical === "제외") {
                if (eDate) {
                  return !(new Date(sDate) <= new Date(data.date) && new Date(data.date) <= new Date(eDate));
                } else {
                  return !(new Date(sDate) <= new Date(data.date));
                }
              }
            }
          });
        }
      }

      if (this.nav.searchKeyword) {
        dataList = dataList.filter((data) => data.label.includes(this.nav.searchKeyword));
      }

      // 페이징은 <table-list-page> 에서 처리
      // const _total = Math.ceil(dataList.length / this.nav.perPage);
      // this.nav.total = _total < 1 ? 1 : _total;
      //
      // const perPage = this.nav.perPage;
      // const currentPage = this.nav.currentPage;
      //
      // const start = (currentPage - 1) * perPage;
      // const end = currentPage * perPage;

      this.renderTableDataList = dataList
    },
    onClickDetail(data) {
      const postId = data.postId;
      this.$router.push({
        path: `/project/6/tab/450/write/${postId}`,
      });
    },
    onClickTableRow(postId) {
      this.$router.push({
        path: `/project/6/tab/450/write/${postId}`,
      });
    }
  },
};
</script>

<style lang="scss" scoped>
table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    font-size: 14px;
    font-weight: 400;
    text-align: center;

    border: 1px solid #cdcdcd;
    padding: 6px;
  }

  th {
    font-weight: 500;
    background: #fafafa;
    padding: 18px 0;
  }
}
</style>
